import React from 'react';
import useLocations from '@ubeya/shared/hooks/account/useLocations';
import { TextWithTooltip } from '../../Tooltip';

const LocationsChip = ({ value }) => {
  const { mappedLocations } = useLocations();

  const text = Array.isArray(value)
    ? value.map((item) => mappedLocations[item]?.name).join(', ')
    : mappedLocations[value]?.name || value;

  return <TextWithTooltip tooltipBodyMaxWidth={300}>{text}</TextWithTooltip>;
};

export default LocationsChip;
